const STORAGE_KEY = "ss:supplier-match-dashboard-dismissed";

/**
 * Whether the salon has dismissed the home dashboard's Supplier Match
 * onboarding invite (ADR-0005 "Onboarding: offered once as a skippable
 * step"). Client-only - there is no backend flag for this, deliberately;
 * the full settings page always stays reachable regardless.
 */
export function isSupplierMatchOnboardingDismissed(): boolean {
  try {
    return localStorage.getItem(STORAGE_KEY) === "1";
  } catch {
    return false;
  }
}

export function dismissSupplierMatchOnboarding(): void {
  try {
    localStorage.setItem(STORAGE_KEY, "1");
  } catch {
    // Ignore write failures (e.g. private mode / quota); the caller's own
    // state update still hides the invite for the rest of this session.
  }
}
